import { Summary } from "features/shared/styles/typography/Summary.styled";
import styled from "styled-components";

import ButtonGroup from "./ButtonGroup.styled";

const ScanningCard = styled.div`
  max-width: 640px;
  background-color: ${({ theme }) => theme.colors.baseWhite};
  padding: 24px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusChecklistCard};
  border: 1px solid ${({ theme }) => theme.colors.base3};

  ${Summary} {
    margin-bottom: 24px;
  }

  ${ButtonGroup} {
    margin-top: 24px;
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    ${ButtonGroup}.with-rescan-button {
      flex-direction: column-reverse;
    }

    .cancel-button {
      display: none;
    }
  }
`;

export default ScanningCard;
